module.exports = __webpack_public_path__ + "img/history.2e043aaa.png";